import n from "react";
import { XCircle as p } from "@olxbr/ds-icons";
import { HelpTextDefaultProps as _ } from "./props.js";
import { cls as d } from "../../helpers/cls.js";
var x = Object.defineProperty,
  o = Object.getOwnPropertySymbols,
  c = Object.prototype.hasOwnProperty,
  f = Object.prototype.propertyIsEnumerable,
  m = (e, r, a) => r in e ? x(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  E = (e, r) => {
    for (var a in r || (r = {})) c.call(r, a) && m(e, a, r[a]);
    if (o) for (var a of o(r)) f.call(r, a) && m(e, a, r[a]);
    return e;
  },
  O = (e, r) => {
    var a = {};
    for (var l in e) c.call(e, l) && r.indexOf(l) < 0 && (a[l] = e[l]);
    if (e != null && o) for (var l of o(e)) r.indexOf(l) < 0 && f.call(e, l) && (a[l] = e[l]);
    return a;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const i = e => {
  var r = e,
    {
      children: a,
      className: l,
      isError: t
    } = r,
    s = O(r, ["children", "className", "isError"]);
  return t && Object.assign(s, {
    role: "alert"
  }), n.createElement("span", E({
    className: d("olx-help-text", l, t && "olx-help-text--error"),
    "data-ds-component": "DS-HelpText"
  }, s), t && n.createElement("span", {
    className: "olx-help-text__icon"
  }, n.createElement(p, {
    size: "16px"
  })), a);
};
i.displayName = "HelpText", i.defaultProps = _;
export { i as HelpText };